/**
 * 明細の表示方法の定数定義
 */
export const ReceiptDisplayMethod = {
  PlanSubjectSet: 'plan_subject_set',
  PlanSubjectSetByDate: 'plan_subject_set_by_date',
  SubjectName: 'subject_name',
} as const

export type ReceiptDisplayMethodType = (typeof ReceiptDisplayMethod)[keyof typeof ReceiptDisplayMethod]
